import { TeamsCard } from '../components/TeamsCard'
import { useTeamsPageController } from './useTeamsController'
import { TeamAdd } from '../components/TeamAdd'
import { Button } from '../../../components/ui/button'
import { Spinner } from '../../../components/ui/spinner'
import { FormProvider } from 'react-hook-form'
import { Input } from '../../../components/ui/input'
import { ArrowDownUp, Search } from 'lucide-react'
import ButtonBack from '@/view/components/ButtonBack'
import { DateRangePicker } from '@/view/components/DateRangePicker'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/view/components/ui/select'

export const TeamsPage = () => {
  const {
    handleGoToTeamsPage,
    data,
    hasNextPage,
    isFetching,
    isFetchingNextPage,
    ref,
    methods,
    handleSearchInputChange,
    searchValue,
    onSelect,
    selectedDate,
    supervisorName,
    isFromManagerDetails,
    PERMISSIONS,
    sort,
    order,
    handleSortChange,
    handleOrderChange,
    teams,
    emptyMessage,
  } = useTeamsPageController()

  return (
    <div>
      <div className="flex items-end justify-between">
        <div>
          <h2 className="mb-8 text-2xl font-semibold">
            {isFromManagerDetails ? (
              <ButtonBack label={supervisorName} />
            ) : (
              `Gerenciar equipes (${(data?.pages[0]?.pagination.total || 0).toLocaleString('pt-BR')})`
            )}
          </h2>
        </div>
      </div>
      <div className="mb-8 flex items-center justify-between">
        <div className="relative flex items-center">
          <Search size={20} className="z-2 absolute left-4 top-3" />
          <Input
            className="ml-1 w-52 rounded-3xl pl-10 md:w-72"
            placeholder="Pesquisar por nome ou CPF"
            onChange={handleSearchInputChange}
            value={searchValue}
          />
          <div className="ml-4">
            <DateRangePicker
              date={selectedDate}
              onDateChange={onSelect}
              numberOfMonths={1}
            />
          </div>

          <div className="ml-4 flex items-center gap-2">
            <Select value={sort} onValueChange={handleSortChange}>
              <SelectTrigger className="w-48">
                <SelectValue placeholder="Ordenar por" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="name">Nome</SelectItem>
                <SelectItem value="createdAt">Data de criação</SelectItem>
                <SelectItem value="transactions_total">
                  Valor movimentado
                </SelectItem>
              </SelectContent>
            </Select>
            <Button
              variant="outline"
              size="icon"
              onClick={handleOrderChange}
              title={order === '-1' ? 'Decrescente' : 'Crescente'}
            >
              <ArrowDownUp
                size={16}
                className={order === '1' ? 'rotate-180' : ''}
              />
            </Button>
          </div>
        </div>

        {PERMISSIONS.team.create && (
          <FormProvider {...methods}>
            <TeamAdd />
          </FormProvider>
        )}
      </div>

      <div className="space-y-4">
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(386px, 1fr))',
            gap: '16px',
          }}
        >
          {teams.map((team) => (
            <TeamsCard
              {...team}
              key={team._id}
              handleGoToTeamsPage={handleGoToTeamsPage}
            />
          ))}
        </div>

        {emptyMessage && !isFetching ? (
          <p className="py-10 text-center text-sm text-muted-foreground">
            {emptyMessage}
          </p>
        ) : null}
      </div>

      <div className="mt-2 flex items-center justify-center" ref={ref}>
        <Button variant="ghost" disabled={!hasNextPage || isFetchingNextPage}>
          {isFetchingNextPage ? <Spinner /> : null}
        </Button>
      </div>
      <div>
        {isFetching && !isFetchingNextPage ? (
          <div className="flex items-center justify-center">
            <Spinner />
          </div>
        ) : null}
      </div>
    </div>
  )
}
